import * as React from 'react';
import MaterialUIBadge, { BadgeProps } from '@material-ui/core/Badge';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const styles = (theme: Theme) =>
  createStyles({
    badge: {
      width: 'auto',
      fontSize: theme.typography.pxToRem(10),
      transform: 'translate(70%, -70%)'
    },
    invisible: {
      display: 'none'
    }
  });

type Props = WithStyles<typeof styles> & Partial<BadgeProps>;

const BadgeComponent: React.FC<Props> = ({ badgeContent, classes, children, color = 'error' }) => {
  const { t } = useTranslation();
  const itemsCount = Number(badgeContent);
  return (
    <MaterialUIBadge
      badgeContent={badgeContent}
      children={children}
      classes={{
        badge: classes.badge,
        invisible: classes.invisible
      }}
      color={color}
      title={t('components.badgeTooltip', {
        count: itemsCount,
        defaultValue_plural: 'items require action',
        defaultValue: 'item requires action'
      })}
    />
  );
};

export const AvatarBadge = withStyles(styles)(BadgeComponent);
